import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';

import { Link } from 'react-router-dom';

const Card = styled.div<CardProp>`
  text-align: center;
  width: 198px;
  height: 303px;
  border-radius: 8px;
  padding: 40px;
  position: relative;
  background-image: url(${(props: CardProp) => props.bgImg}),
    linear-gradient(
      to top left,
      ${(props: CardProp) => props.gradientColor.first} 0.01%,
      ${(props: CardProp) => props.gradientColor.second} 100%
    );
  background-size: 198px 303px;
  cursor: pointer;

  img:nth-of-type(2) {
    opacity: 0;
  }
  // 切換圖片
  :hover {
    img:nth-of-type(1) {
      opacity: 0;
    }
    img:nth-of-type(2) {
      top: -70px;
      opacity: 1;
    }
  }
`;
const CardImg = styled.img`
  height: 182px;
  position: absolute;
  top: -60px;
  left: 25px;
`;
const CardTitle = styled.div`
  color: ${colors.BlueGray_0};
  font-family: NotoSansTC-Bold;
  font-size: 28px;
  line-height: 41px;
  margin-top: 70px;
`;
const CardContent = styled.div`
  color: ${colors.BlueGray_0};
  font-family: NotoSansTC-Regular;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  margin-top: 12px;
`;

type CardProp = {
  gradientColor: {
    first: string;
    second: string;
  };
  bgImg: string;
};

interface IProps {
  href: string;
  title: string;
  description: string;
  gradientColor: {
    first: string;
    second: string;
  };
  image: string;
  hoverImage: string;
  bgImg: string;
}

const DeskTopCard: React.FC<IProps> = ({
  href,
  title,
  description,
  gradientColor,
  image,
  hoverImage,
  bgImg,
}) => {
  return (
    <Link to={href}>
      <Card bgImg={bgImg} gradientColor={gradientColor}>
        <CardImg src={image} alt="" ></CardImg>
        <CardImg src={hoverImage} alt="" ></CardImg>
        <CardTitle>{title}</CardTitle>
        <CardContent>{description}</CardContent>
      </Card>
    </Link>
  );
};

export default DeskTopCard;
